import React from "react";

export default function Loader() {
  return (
    <div className="loader-background">
      <div className="loader"></div>
    </div>
  );
}
